/*
 * GT wholesale catalog - inline variant chips for 2-4 variant products.
 *
 * Markup comes from snippets/gt-wholesale-product-card.liquid:
 *   [data-gt-variant-chips] > button[data-gt-variant-id]   (one per Shopify variant;
 *                                                          sold-out ones are `disabled`)
 *   form input[name="id"]      starts EMPTY - nothing is preselected
 *   form [type="submit"]       starts disabled + [data-gt-variant-pending]
 *
 * Picking a chip writes that exact variant id into THIS card's id input and
 * enables the button. The add itself stays with Dawn's product-form.js (same
 * Ajax /cart/add, loading state and cart-drawer refresh) - there is no second
 * add-to-cart path here. All state lives in the card's own DOM, so cards are
 * independent; listeners are document-delegated so facet/pagination re-renders
 * need no re-binding. No user-facing strings (labels come from Liquid/locales).
 */
(function () {
  if (window.__gtCardVariantInit) return;
  window.__gtCardVariantInit = true;

  var CHIPS = '[data-gt-variant-chips]';

  function labelSpan(button) {
    for (var i = 0; i < button.children.length; i++) {
      var el = button.children[i];
      if (el.tagName === 'SPAN' && !el.classList.contains('gt-icon')) return el;
    }
    return null;
  }

  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-gt-variant-id]');
    if (!chip || !chip.closest(CHIPS)) return;
    var card = chip.closest('.gt-card');
    if (!card) return;
    e.preventDefault();
    if (chip.disabled) return;

    var id = chip.getAttribute('data-gt-variant-id');
    var form = card.querySelector('form');
    var input = form ? form.querySelector('input[name="id"]') : null;
    var button = form ? form.querySelector('[type="submit"]') : null;
    if (!id || !input || !button) return;
    // Never touch a card while its add request is in flight.
    if (button.getAttribute('aria-disabled') === 'true') return;

    var chips = card.querySelectorAll(CHIPS + ' [data-gt-variant-id]');
    for (var i = 0; i < chips.length; i++) {
      var on = chips[i] === chip;
      chips[i].classList.toggle('is-selected', on);
      chips[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }

    input.value = id;
    input.disabled = false;

    if (button.hasAttribute('data-gt-variant-pending')) {
      button.removeAttribute('data-gt-variant-pending');
      var span = labelSpan(button);
      var ready = button.getAttribute('data-gt-ready-label');
      if (span && ready) span.textContent = ready;
    }
    button.disabled = false;

    // Show the selected variant's price when variant prices differ.
    var tpl = card.querySelector('template[data-gt-variant-price="' + id + '"]');
    var price = card.querySelector('.gt-price');
    var fresh = tpl && tpl.content ? tpl.content.querySelector('.gt-price') : null;
    if (fresh && price) price.replaceWith(fresh.cloneNode(true));
  });

  // Last line of defence: an inline-variant card may only submit the id of a
  // chip that is currently selected and available. Capture phase on document
  // runs before product-form's own submit listener and stops it outright.
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || !form.closest) return;
      var card = form.closest('.gt-card');
      if (!card || !card.querySelector(CHIPS)) return;
      var input = form.querySelector('input[name="id"]');
      var id = input ? input.value : '';
      var chip = id
        ? card.querySelector(CHIPS + ' [data-gt-variant-id="' + id + '"][aria-pressed="true"]')
        : null;
      if (!chip || chip.disabled) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    true
  );
})();
